import type { MailingSequenceSnapshot } from "@/nango/types/apps.autoleads/autoleads/AutoLeads"

export type SequenceStep = { subject: string; body: string }

const STEP_KEY = /^step(\d+)_(subject|body)$/

// Ordered steps of a drafted sequence. The step count follows the campaign's
// pipeline (email steps only), so it is read from the snapshot, never assumed.
export function sequenceSteps(
  sequence: MailingSequenceSnapshot | undefined,
): SequenceStep[] {
  if (!sequence) return []
  const indexes = Object.keys(sequence)
    .map((key) => Number(STEP_KEY.exec(key)?.[1]))
    .filter((index) => Number.isFinite(index))
  if (indexes.length === 0) return []

  const steps: SequenceStep[] = []
  for (let index = 1; index <= Math.max(...indexes); index++) {
    const subject = sequence[`step${index}_subject`] ?? ""
    const body = sequence[`step${index}_body`] ?? ""
    if (subject || body) steps.push({ subject, body })
  }
  return steps
}
